// extracted by mini-css-extract-plugin
module.exports = {"layout":"src-basic-Layout-module__layout--3_B_C"};